import { Link } from "react-router-dom";
import { useLang } from "@/context/LangContext";

export default function NotFound() {
  const { lang } = useLang();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center bg-[#F9F8F6]">
      <p className="font-display font-black text-[20vw] md:text-[12rem] leading-none text-[#1A1B1A]">404</p>
      <p className="mt-4 text-[#5C635A] text-lg">
        {lang === "es" ? "Esta ruta no existe en Sustrai Aventura." : "This route doesn't exist on Sustrai Aventura."}
      </p>
      <Link to="/" className="mt-8 inline-block bg-[#F26419] hover:bg-[#D95512] text-white font-bold tracking-[0.1em] uppercase px-8 py-4 text-sm">
        {lang === "es" ? "Volver al inicio" : "Back to home"}
      </Link>
    </div>
  );
}
